import { observer } from 'mobx-react-lite';
import { JobLangListViewModel } from './lang-list.view-model';
import { Box, Button, Flex, IconButton, Select, Text } from '@radix-ui/themes';
import { FormField } from 'shared/components';
import { AddIcon, ClearIcon } from 'shared/icons';
import React from 'react';

function LangGroupView({ viewModel }: { viewModel: JobLangListViewModel }) {
   return (
      <Flex className="langs_fields" direction="column" gap="3">
         {viewModel.langGroupControls.map((model, idx) => {
            return (
               <Flex key={model.id} gap="4" align="end" pr={idx > 0 ? '100px' : '0'}>
                  <FormField label="Знання мови">
                     <Select.Root
                        size="3"
                        value={model.langControl.value}
                        onValueChange={(value) => model.langControl.setValue(value)}
                     >
                        <Select.Trigger placeholder="Оберіть мову"></Select.Trigger>
                        <Select.Content
                           color="blue"
                           position="popper"
                           onCloseAutoFocus={(e) => e.preventDefault()}
                        >
                           <Box maxHeight="250px">
                              {viewModel.langOptions.map((lang) => {
                                 return (
                                    <Select.Item key={lang.id} value={lang.id.toString()}>
                                       {lang.name}
                                    </Select.Item>
                                 );
                              })}
                           </Box>
                        </Select.Content>
                     </Select.Root>
                  </FormField>

                  <FormField label="Рівень володіння">
                     <Select.Root
                        size="3"
                        value={model.langSkillControl.value}
                        onValueChange={(value) => {
                           model.langSkillControl.setValue(value);
                        }}
                     >
                        <Select.Trigger placeholder="Оберіть рівень володіння"></Select.Trigger>
                        <Select.Content
                           color="blue"
                           position="popper"
                           onCloseAutoFocus={(e) => e.preventDefault()}
                        >
                           <Box maxHeight="250px">
                              {viewModel.langSkillsOptions.map((lang_skill) => {
                                 return (
                                    <Select.Item
                                       key={lang_skill.id}
                                       value={lang_skill.id.toString()}
                                    >
                                       {lang_skill.name}
                                    </Select.Item>
                                 );
                              })}
                           </Box>
                        </Select.Content>
                     </Select.Root>
                  </FormField>

                  {idx === 0 ? (
                     <Button
                        size="3"
                        className="add-messenger-trigger"
                        variant="outline"
                        type="button"
                        onClick={() => viewModel.onAddControl()}
                     >
                        <Text weight="regular" wrap="nowrap">
                           Додати ще
                        </Text>
                        <AddIcon />
                     </Button>
                  ) : (
                     <IconButton
                        size="3"
                        type="button"
                        variant="outline"
                        onClick={() => viewModel.onRemoveControl(model.id)}
                     >
                        <ClearIcon />
                     </IconButton>
                  )}
               </Flex>
            );
         })}
      </Flex>
   );
}

export const LangGroup = observer(LangGroupView);
